import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Home, MessageSquare } from "lucide-react";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkPageStatus = async () => {
      try {
        // Extract page_id from pathname (remove leading slash)
        const pathname = location.pathname.slice(1) || "home";
        
        // Check if this path corresponds to a draft page
        const { data: pageData } = await supabase
          .from("pages")
          .select("status, page_id")
          .eq("page_id", pathname)
          .maybeSingle();

        if (pageData && pageData.status === "draft") {
          // Page exists but is draft - redirect to home
          navigate("/", { replace: true });
          return;
        }

        // Not a draft page, show 404
        console.error("404 Error: User attempted to access non-existent route:", location.pathname);
        setIsChecking(false);
      } catch (error) {
        console.error("Error checking page status:", error);
        setIsChecking(false);
      }
    };

    checkPageStatus();
  }, [location.pathname, navigate]);

  const handleOpenAIAssistant = () => {
    // Dispatch custom event to open AI Assistant
    window.dispatchEvent(new CustomEvent("openAIAssistant"));
  };

  if (isChecking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center max-w-md px-6">
        <h1 className="mb-4 text-6xl font-bold text-foreground">404</h1>
        <p className="mb-2 text-2xl font-semibold text-foreground">Page Not Found</p>
        <p className="mb-8 text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={() => navigate("/")} size="lg" className="gap-2">
            <Home className="h-4 w-4" />
            Return Home
          </Button>
          <Button onClick={handleOpenAIAssistant} variant="outline" size="lg" className="gap-2">
            <MessageSquare className="h-4 w-4" />
            Open AI Assistant
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
